import React from 'react';
import { FaPlus } from 'react-icons/fa';
import '../styles/Products.css';

const AdminProducts = () => {
  const products = ['Solar Panels','CCTV Cameras','DVR Systems','Network Routers','Electric Fence','TV Mounts','Smart Switches','Circuit Breakers'];
  return (
    <div className="products-page">
      <h1>Products</h1>
      <p>Manage products and equipment.</p>
      <button className="add-btn"><FaPlus /> Add Product</button>
      <table className="products-table">
        <thead><tr><th>#</th><th>Product</th><th>Category</th><th>Price</th><th>Actions</th></tr></thead>
        <tbody>{products.map((p,i)=>(<tr key={i}><td>{i+1}</td><td>{p}</td><td>Equipment</td><td>Contact</td><td><button className="edit-btn">Edit</button> <button className="delete-btn">Delete</button></td></tr>))}</tbody>
      </table>
    </div>
  );
};
export default AdminProducts;
